import { useLanguage } from "context/LanguageContext";
import { useNavigate } from "react-router-dom";
import WisdomNavbar from "components/navbars/WisdomNabvar";


const WisdomPdms = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();

    const dashboard = () => {
        navigate(`/wisdom/pdms/dashboard`);
    };

    const classObservation = () => {
        navigate('/pms/form/84', { state: { formEnName: "ملاحظة الصفية", formArName: "ملاحظة الصفية", code: "Employee", reviewee: null } });
    };

    const interview = () => {
        navigate(`/pdms/interview`);
    };

    const pedagogicalTest = () => {
        navigate(`/pdms/pedagogical-test`);
    };

    const mainMenu = [
        {

            label: language ? "Dashboard" : "Dashboard",
            color: "from-watomsBlue to-wisdomOrange",
            onClick: dashboard,
        },
        {

            label: language ? "ملاحظة صفية" : "ملاحظة صفية",
            color: "from-watomsBlue to-wisdomOrange",
            onClick: classObservation,
        },
        {

            label: language ? "مقابلة شخصية" : "مقابلة شخصية",
            color: "from-watomsBlue to-wisdomOrange",
            onClick: interview,
        },
        {

            label: language ? "اختبار تربوي" : "اختبار تربوي",
            color: "from-watomsBlue to-wisdomOrange",
            onClick: pedagogicalTest,
        }
    ];
    return (
        <>
            <WisdomNavbar />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-12 w-full p-4">
                {mainMenu.map((item, idx) => (
                    <div
                        key={item.label}
                        className={`flex flex-col items-center justify-center bg-gradient-to-br ${item.color} rounded-3xl shadow-xl p-10 cursor-pointer hover:scale-105 transition-transform duration-300 group backdrop-blur-sm`}
                        style={{ minHeight: '220px' }}
                        onClick={item.onClick}
                    >
                        <span className="text-2xl font-extrabold text-white text-center drop-shadow-lg group-hover:scale-105 transition-transform duration-300">
                            {item.label}
                        </span>
                    </div>
                ))}
            </div>
        </>
    )
};

export default WisdomPdms;